import React from 'react';

import {graphql} from 'gatsby';
import {BackgroundImageHeroFragment} from '@graphql-types';

import * as styles from './backgroundHeroImage.module.scss';

const BackgroundImageHero = (props: BackgroundImageHeroFragment) => {
  return (
    <div className={styles.wrapper}>
      <div
        className={styles.content}
        style={{
          backgroundImage: 'url(' + props.primary.background_image.url + ')',
        }}>
        <div className={styles.textContent}>
          <div
            dangerouslySetInnerHTML={{__html: props.primary.hero_text.html}}
          />
        </div>
      </div>
    </div>
  );
};

export default BackgroundImageHero;

export const backgroundImageHeroFragment = graphql`
  fragment backgroundImageHero on PrismicPageDataBodyBackgroundImageHero {
    id
    slice_type
    primary {
      hero_text {
        html
      }
      background_image {
        url
      }
    }
  }
`;
